<div class="modal-header h2">Failure in P6 activation</div>
<div class="modal-body">
  <p>There is a connection issue between Job Id Card and the Primavera servers. Your job card will be automatically activated when the connection is restored.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" id="okButton" (click)="onConfirm()">Ok</button>
</div>
